module.exports = __webpack_public_path__ + "img/Portafolio Patriot_5.32297668.png";